import { useTranslation } from "react-i18next";

import BaseCard from "@/components_v2/Card/BaseCard";
import BaseDivider from "@/components_v2/Divider/BaseDivider";
import {
  PathCardProps,
  PathCardSectionProps,
} from "@/features/certifications/details/components/types";

import "./styles.css";

const PathCardSection = ({ title, children }: PathCardSectionProps) => (
  <div className="flex flex-col gap-200">
    <h4 className="path-card-section-title">{title}</h4>
    {children}
  </div>
);

const PathCard = ({ copy, isHighlighted, footer }: PathCardProps) => {
  const { t } = useTranslation();
  const hasFacts = Boolean(copy.timePerWeek || copy.credential);

  return (
    <BaseCard
      className={`path-card flex flex-col full-height ${isHighlighted ? "path-card-highlighted" : ""}`}
    >
      {isHighlighted && (
        <span className="path-card-highlight">
          {t("certification.details.mostChosen")}
        </span>
      )}

      <div className="flex flex-col justify-between full-height gap-400">
        <div className="flex flex-col gap-400">
          <div className="flex flex-col gap-200">
            {copy.eyebrow && (
              <span className="path-card-label">{copy.eyebrow}</span>
            )}

            <h3 className="path-card-title header-l-medium">{copy.title}</h3>

            {copy.summary && (
              <p className="path-card-description body-s-regular">
                {copy.summary}
              </p>
            )}
          </div>

          <BaseDivider />

          {copy.requirements.length > 0 && (
            <PathCardSection
              title={t("certification.details.requirementsTitle")}
            >
              <ul className="path-card-section-items body-s-regular flex flex-col gap-100">
                {copy.requirements.map((requirement) => (
                  <li key={requirement}>{requirement}</li>
                ))}
              </ul>

              {copy.requirementsNote && (
                <p className="path-card-section-note body-xs-regular">
                  {copy.requirementsNote}
                </p>
              )}
            </PathCardSection>
          )}

          {hasFacts && (
            <dl className="path-card-facts gap-300">
              <div className="flex flex-col gap-50">
                <dt className="path-card-fact-label">
                  {t("certification.details.timePerWeek")}
                </dt>

                <dd className="path-card-fact-value body-s-medium">
                  {copy.timePerWeek}
                </dd>
              </div>

              <div className="flex flex-col gap-50">
                <dt className="path-card-fact-label">
                  {t("certification.details.credential")}
                </dt>

                <dd className="path-card-fact-value body-s-medium">
                  {copy.credential}
                </dd>
              </div>
            </dl>
          )}

          {copy.represents && (
            <PathCardSection title={t("certification.details.representsTitle")}>
              <p className="path-card-section-body body-s-regular">
                {copy.represents}
              </p>
            </PathCardSection>
          )}

          {copy.suits && (
            <PathCardSection title={t("certification.details.suitsTitle")}>
              <p className="path-card-section-body body-s-regular">
                {copy.suits}
              </p>
            </PathCardSection>
          )}
        </div>

        <div className="flex flex-col gap-300">
          <BaseDivider />

          {footer}
        </div>
      </div>
    </BaseCard>
  );
};

export default PathCard;
